<template>
  <div class="privacy-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="section-container">
        <h1 class="page-header__title">{{ t.title }}</h1>
        <div class="page-header__breadcrumb">
          <router-link to="/">Home</router-link>
          <span>/</span>
          <span>{{ t.title }}</span>
        </div>
      </div>
    </div>

    <!-- Privacy Content -->
    <section class="section">
      <div class="section-container">
        <div class="privacy-content animate-on-scroll">
          <div class="privacy-card">
            <p class="intro">{{ t.intro }}</p>

            <template v-for="(section, s) in t.sections">
              <h3 :key="'h' + s">{{ section.title }}</h3>
              <template v-for="(block, b) in section.blocks">
                <p v-if="block.p" :key="s + '-' + b">{{ block.p }}</p>
                <ul v-else :key="s + '-' + b">
                  <li v-for="(item, i) in block.ul" :key="i">{{ item }}</li>
                </ul>
              </template>
            </template>

            <div class="privacy-contact">
              <p>{{ t.contact }} <a href="mailto:info@miraverse.id">info@miraverse.id</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import copy from '@/locales/privacy'

export default {
  name: 'PrivacyPage',
  computed: {
    t() {
      return copy[this.$lang]
    }
  },
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { entry.target.classList.add('animated') }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.privacy-content {
  max-width: 800px;
  margin: 0 auto;
}

.privacy-card {
  background: #fff;
  border-radius: 20px;
  padding: 48px;
  box-shadow: 0 4px 24px rgba(108, 41, 115, 0.08);
  border: 1px solid rgba(108, 41, 115, 0.06);

  .intro {
    font-size: 1.05rem;
    color: $text-body;
    line-height: 1.8;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(108, 41, 115, 0.08);
  }

  h3 {
    margin-top: 28px;
    margin-bottom: 12px;
    font-size: 1.2rem;
    color: $text-dark;
  }

  p {
    color: $text-body;
    line-height: 1.8;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 16px;

    li {
      color: $text-body;
      margin-bottom: 8px;
      line-height: 1.6;
      position: relative;

      &::marker {
        color: #C73468;
      }
    }
  }
}

.privacy-contact {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(108, 41, 115, 0.08);

  a {
    color: #6C2973;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: #C73468;
    }
  }
}

@media (max-width: 576px) {
  .privacy-card {
    padding: 28px 20px;
  }
}
</style>